.component {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: $baseline-2;
  border: 0;
  cursor: pointer;
  font-family: inherit;
  background: transparent;
  text-align: left;
  color: $color-gray; // default color for description/subtitle

  @include bp-sm {
    padding-top: $baseline-3;
    padding-bottom: $baseline-3;
  }

  &.borderless {
    padding-left: 0;
    padding-right: 0;

    &.is-first-item {
      padding-top: 0;
    }

    &.is-last-item {
      padding-bottom: 0;
    }
  }

  &:hover {
    .arrow {
      @include arrow($token-surface-interaction-hover);
    }
  }

  &.open {
    .arrow {
      @include arrow--up;
    }
  }

  &.left {
    flex-direction: row-reverse;

    .header {
      padding-left: $baseline; // prevent content from crashing into arrow
    }
  }

  &.right {
    .header {
      padding-right: $baseline; // prevent content from crashing into arrow
    }
  }

  &.center {
    justify-content: center;
    min-height: $baseline-4;
    border-top: 1px solid $color-accordion-border;

    .header {
      display: none;
    }
  }

  .header {
    flex: 1; // ensure slot stretches 100%
  }

  .arrow {
    @include arrow(inherit);
    @include arrow--down;
    width: $arrow-width;
    background: $token-surface-interaction-default;
  }

  @include focus-visible;
}

.component.sdx--dark-theme {
  color: $color-gray-dark-theme; // for headline and description/subtitle

  &:hover {
    .arrow {
      @include arrow($color-int-blue-dark-theme--active);
    }
  }

  @include focus-visible--dark-theme;

  .arrow {
    background: $color-int-blue-dark-theme;
  }

  &.center {
    border-top-color: $color-gray-tint-7-dark-theme;
  }
}
